// LOCAL DEVELOPMENT
// import * as slot_core from '@gamzix/slot_core';
//
// Object.entries(slot_core).forEach(([key, value]) => {
//     global[key] = value;
// });
// END OF LOCAL DEVELOPMENT

import './GameSlotGameSubController';

import '../components/preloader/src/index';
import '../components/background/src/index';
import '../components/preview/src/index';
import '../components/ui/src/index'
import '../components/reelset/src/index';
import '../components/bigWin/src/index';
import '../components/ui/src/index';
import '../components/intrigue/src/index';
import '../components/jackpotPanel/src/index';
import '../components/coinAnimation/src/index';
import '../components/winSymbolScale/src/index';
import '../components/bonusGame/src/index';

window.gameRun();